import { PaddingType } from "../types/padding";

export const PaddingNames: Record<PaddingType, string> = {
    none: "No Padding",
    top: "Top",
    bottom: "Bottom",
    top_and_bottom: "Top & Bottom",
};

export const paddingNamesObject = { ...PaddingNames };
export const paddingNamesList = (Object.keys(PaddingNames) as Array<keyof typeof PaddingNames>).map(
    (key) => PaddingNames[key],
);
export const paddingKeysList = Object.keys(PaddingNames) as Array<keyof typeof PaddingNames>;
